export default class incomingSmsBuilder {
    constructor() {
        return {
            restrict: 'E',
            scope: {
                structure: '=',
                customFields: '=',
                keyword: '='
            },
            template: require('../../../../views/setting/partials/incoming-sms-builder.html'),
            controller: IncomingTextMessageCtrl,
            controllerAs: 'incoming'
        }
    }
};

class IncomingTextMessageCtrl {
    constructor($scope, $filter, $timeout, Tag, Events) {
        this._translator = $filter('translate');
        this._scope = $scope;

        this.tagRepo = Tag;
        this.eventHandler = Events;

        this.labelText = this._translator('SETTING:INCOMING:STORE_WORD_AS');
        this.loadedTags = [];

        this.tagRepo.all().then((tags) => {
            this.tags = tags.data;
        });

        this._scope.$watch('structure', (newVal) => {
            if (newVal) {
                this.loadedTags = this.getLoadedTags(this._scope.structure.tag);
                $timeout(() => {
                    this.checkForDisabled();
                }, 500);
            }
        });
    }

    hasEmptyFields() {
        let res = false;

        angular.forEach(this._scope.structure.fields, (field) => {
            if (field.type == 'custom_field' && field.id == null) {
                res = true;
                this.eventHandler.flashEvent('error', this._translator('SETTING:INCOMING:EMPTY_FIELD_ERROR'));
            }
        });

        return res;
    };

    addField() {
        if (! this._scope.structure.fields) {
            this._scope.structure.fields = [];
        }

        if (this._scope.structure.fields.length > 5) {
            return this.eventHandler.flashEvent('error', this._translator('SETTING:INCOMING:MAX_6_FIELDS_FLASH'));
        }

        if (! this.hasEmptyFields()) {
            this._scope.structure.fields.push({ type: 'custom_field', id: null });
        }
    };

    addEmail() {
        if (this._scope.structure.fields && this._scope.structure.fields.length > 5) {
            return this.eventHandler.flashEvent('error', this._translator('SETTING:INCOMING:MAX_6_FIELDS_FLASH'));
        }

        if (! this._scope.structure.fields || this._scope.structure.fields.length == 0) {
            this._scope.structure = { fields: [] };
            this._scope.structure.fields.push({ type: 'email' });
        } else {
            let hasEmail = false;

            angular.forEach(this._scope.structure.fields, (field, index) => {
                if (field.type == 'email') {
                    hasEmail = true;
                    this.eventHandler.flashEvent('error', this._translator('SETTING:INCOMING:ONLY_ONE_EMAIL'));
                } else if (index == this._scope.structure.fields.length - 1 && ! hasEmail) {
                    this._scope.structure.fields.push({ type: 'email' });
                }
            });
        }
    };

    checkForDisabled() {
        angular.forEach(this._scope.customFields, (field) => {
            field.disabled = false; // reset.

            angular.forEach(this._scope.structure.fields, (activeField) => {
                if (activeField.id == field.fieldId) {
                    field.disabled = true; // disable.
                }
            });
        });
    };

    removeTerm(index) {
        this._scope.structure.fields.splice(index, 1);
        this.checkForDisabled();
    };

    save() {
        if (! this.hasEmptyFields()) {
            this._scope.$emit('sender:incomingStructure:update');
        }
    };

    clearTag() {
        this._scope.structure['tag'] = null;
    };

    itemText(index) {
        return this.labelText.replace(':num', index);
    };

    getLoadedTags(loadedTags) {
        var tags = [];

        if (loadedTags) {
            if (typeof loadedTags === 'string') {
                tags.push({'id': loadedTags});
            } else {
                for (var i=0; i<loadedTags.length; i++) {
                    tags.push({'id': loadedTags[i]});
                }
            }
        }

        return tags;
    };
}
